var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0051 9L12.0638 9C12.39 9 12.657 8.70863 12.657 8.35252C12.657 7.9964 12.39 7.70504 12.0638 7.70504L5.0051 7.70504C4.67885 7.70504 4.41193 7.9964 4.41193 8.35252C4.41193 8.72482 4.67885 9 5.0051 9Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0051 5.14746L14.4068 5.14746C14.7331 5.14746 15 4.85609 15 4.49998C15 4.14386 14.7331 3.8525 14.4068 3.8525L5.0051 3.8525C4.67885 3.8525 4.41193 4.14386 4.41193 4.49998C4.41193 4.87228 4.67885 5.14746 5.0051 5.14746Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0051 1.29492L13.2353 1.29492C13.5616 1.29492 13.8285 1.00355 13.8285 0.64744C13.8285 0.291325 13.5616 -4.23193e-05 13.2353 -4.23193e-05L5.0051 -4.23193e-05C4.67885 -4.23193e-05 4.41193 0.291325 4.41193 0.64744C4.41193 1.01974 4.67885 1.29492 5.0051 1.29492Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46091 9H2.63242C2.95867 9 3.22559 8.70863 3.22559 8.35252C3.22559 7.9964 2.95867 7.70504 2.63242 7.70504H1.46091C1.13467 7.70504 0.867744 7.9964 0.867744 8.35252C0.882574 8.72482 1.1495 9 1.46091 9Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46091 5.14746H2.63242C2.95867 5.14746 3.22559 4.85609 3.22559 4.49998C3.22559 4.14386 2.95867 3.8525 2.63242 3.8525H1.46091C1.13467 3.8525 0.867744 4.14386 0.867744 4.49998C0.882574 4.87228 1.1495 5.14746 1.46091 5.14746Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46091 1.29492L2.63242 1.29492C2.95867 1.29492 3.22559 1.00355 3.22559 0.64744C3.22559 0.291325 2.95867 -4.23193e-05 2.63242 -4.23193e-05L1.46091 -4.23193e-05C1.13467 -4.23193e-05 0.867744 0.291325 0.867744 0.64744C0.882574 1.01974 1.1495 1.29492 1.46091 1.29492Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListNav);
export default __webpack_public_path__ + "static/media/list-nav.ca6b92dcac0b512255dbb2afc2180ccc.svg";
export { ForwardRef as ReactComponent };